module.exports = __webpack_public_path__ + "static/media/close.21c2d771.svg";